(() => {
  const instances = new WeakMap();
  function mount(root) {
    if (instances.has(root)) return;
    const chapters = [...root.querySelectorAll('[data-chapter]')];
    const scenes = [...root.querySelectorAll('[data-scene]')];
    const links = [...root.querySelectorAll('[data-chapter-link]')];
    const track = root.querySelector('.ga-timeline-track');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let frame = 0;
    let active = '';
    function update() {
      frame = 0;
      const threshold = Math.min(innerHeight * .42, 340);
      let current = chapters[0];
      for (const chapter of chapters) if (chapter.getBoundingClientRect().top <= threshold) current = chapter;
      if (current && active !== current.dataset.chapter) {
        active = current.dataset.chapter;
        chapters.forEach(chapter => chapter.classList.toggle('is-active', chapter === current));
        scenes.forEach(scene => scene.classList.toggle('is-active', scene.dataset.scene === active));
        links.forEach(link => {
          if (link.dataset.chapterLink === active) link.setAttribute('aria-current', 'step');
          else link.removeAttribute('aria-current');
        });
      }
      const rect = track.getBoundingClientRect();
      track.style.setProperty('--ga-progress', Math.max(0, Math.min(1, (threshold - rect.top) / rect.height)).toFixed(3));
    }
    const queue = () => { if (!frame) frame = requestAnimationFrame(update); };
    const onClick = event => {
      const link = event.target.closest('a[href^="#story-chapter-"],a[href="#our-journey"]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = root.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduced.matches ? 'instant' : 'smooth', block: 'start' });
      history.replaceState(null, '', link.getAttribute('href'));
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    };
    const observer = new IntersectionObserver(entries => {
      root.classList.toggle('is-outside-hero', !entries[0].isIntersecting);
    });
    observer.observe(root.querySelector('.ga-hero'));
    addEventListener('scroll', queue, { passive: true });
    addEventListener('resize', queue);
    root.addEventListener('click', onClick);
    instances.set(root, () => {
      observer.disconnect(); cancelAnimationFrame(frame);
      removeEventListener('scroll', queue); removeEventListener('resize', queue);
      root.removeEventListener('click', onClick); instances.delete(root);
    });
    update();
  }
  const init = scope => scope.querySelectorAll('[data-geosort-about]').forEach(mount);
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-geosort-about]').forEach(root => instances.get(root)?.()));
})();
